// Coordonnées des formations.
//
// CONTRAINTE DE LISIBILITÉ, à respecter pour toute formation ajoutée : deux créneaux
// dont les abscisses sont proches (|Δx| ≤ 16) doivent avoir au moins SEIZE points
// d'écart en ordonnée. En dessous, leurs jetons se chevauchent sur un terrain de
// téléphone — c'est arrivé au gardien et à l'axial central de toutes les défenses à
// trois et à cinq, qui n'avaient que douze ou treize points d'écart. Un test vérifie
// cette contrainte formation par formation ; le terrain, lui, réduit la taille des
// jetons si elle venait malgré tout à être enfreinte. x% : 0 = touche gauche. y% : 0 = ligne de but de l'AJA.
//
// Les bandes sont canoniques et c'est ce qui rend les formations DISTINGUABLES sur
// 390 px de large : GB 6 · axiaux 19-22 · latéraux 26 · sentinelle 37-40 · double
// pivot 40 · relayeurs 46-52 · pistons 50-54 · dix 64-66 · ailiers 72-74 · pointe
// 83-85. Une version antérieure plaçait le 6 d'un 4-3-3 à y=43 et les 8 à y=47 :
// quatre points d'écart, les jetons se chevauchaient et le 4-3-3 devenait impossible
// à distinguer d'un 4-3-3 à triangle inversé. Le triangle pointe en bas EST la
// définition du système ; il lui faut 12 à 15 points.

export const FORMATIONS = {
  // Le système du dernier match (Brest, 20/09/26) : 3 axiaux, 2 pistons, 2 dix.
  '3-4-2-1': [
    { code: 'GB', x: 50, y: 4 },
    { code: 'DC', x: 26, y: 24 }, { code: 'DC', x: 50, y: 21 }, { code: 'DC', x: 74, y: 24 },
    { code: 'PG', x: 10, y: 50 },
    { code: 'MDC', x: 38, y: 40 }, { code: 'MDC', x: 62, y: 40 },
    { code: 'PD', x: 90, y: 50 },
    { code: 'MOC', x: 34, y: 66 }, { code: 'MOC', x: 66, y: 66 },
    { code: 'BU', x: 50, y: 85 },
  ],

  // Le système annoncé par Will Still à son arrivée (et aligné à Nice, 12/09/26).
  '4-3-3': [
    { code: 'GB', x: 50, y: 4 },
    { code: 'DG', x: 12, y: 26 }, { code: 'DC', x: 34, y: 21 },
    { code: 'DC', x: 66, y: 21 }, { code: 'DD', x: 88, y: 26 },
    { code: 'MDC', x: 50, y: 38 },
    { code: 'MC', x: 30, y: 52 }, { code: 'MC', x: 70, y: 52 },
    { code: 'AIG', x: 14, y: 72 }, { code: 'BU', x: 50, y: 84 }, { code: 'AID', x: 86, y: 72 },
  ],

  // L'écart double pivot (40) → ligne de 3 (64-66) est ce qui distingue un 4-2-3-1
  // d'un 4-3-3 : il doit être franc. Et le 10 est le SOMMET de l'arc, pas son creux —
  // une version antérieure le plaçait à y=61 derrière des ailiers à 63, à l'envers.
  '4-2-3-1': [
    { code: 'GB', x: 50, y: 4 },
    { code: 'DG', x: 12, y: 26 }, { code: 'DC', x: 34, y: 21 },
    { code: 'DC', x: 66, y: 21 }, { code: 'DD', x: 88, y: 26 },
    { code: 'MDC', x: 34, y: 40 }, { code: 'MDC', x: 66, y: 40 },
    { code: 'AIG', x: 14, y: 64 }, { code: 'MOC', x: 50, y: 66 }, { code: 'AID', x: 86, y: 64 },
    { code: 'BU', x: 50, y: 85 },
  ],

  // Le 3-4-2-1 quand l'AJA court après le score.
  '3-4-3': [
    { code: 'GB', x: 50, y: 4 },
    { code: 'DC', x: 26, y: 24 }, { code: 'DC', x: 50, y: 21 }, { code: 'DC', x: 74, y: 24 },
    { code: 'PG', x: 10, y: 50 },
    { code: 'MDC', x: 38, y: 40 }, { code: 'MDC', x: 62, y: 40 },
    { code: 'PD', x: 90, y: 50 },
    // Ailiers plus resserrés qu'en 4-3-3 : dans un système à 3 derrière, la largeur
    // vient des pistons, pas des ailiers.
    { code: 'AIG', x: 20, y: 74 }, { code: 'BU', x: 50, y: 84 }, { code: 'AID', x: 80, y: 74 },
  ],

  // Dans un 4-4-2 plat, les côtés sont des MILIEUX, pas des ailiers : ils forment la
  // ligne de 8 à la récupération. Les coder AIG/AID donnait 2/2 à un ailier qui ne
  // défend pas et 1/2 à un vrai milieu droit — le classement de la feuille « Qui joue
  // ici ? » sortait à l'envers. Et une ligne plate doit être plate.
  '4-4-2': [
    { code: 'GB', x: 50, y: 4 },
    { code: 'DG', x: 12, y: 26 }, { code: 'DC', x: 34, y: 21 },
    { code: 'DC', x: 66, y: 21 }, { code: 'DD', x: 88, y: 26 },
    { code: 'MG', x: 12, y: 47 }, { code: 'MC', x: 37, y: 46 },
    { code: 'MC', x: 63, y: 46 }, { code: 'MD', x: 88, y: 47 },
    { code: 'BU', x: 38, y: 80 }, { code: 'BU', x: 62, y: 80 },
  ],

  // Dans un 3-5-2 les pistons sont la SEULE largeur de l'équipe : ils montent plus
  // haut que dans un 3-4-2-1, pas moins.
  '3-5-2': [
    { code: 'GB', x: 50, y: 4 },
    { code: 'DC', x: 26, y: 24 }, { code: 'DC', x: 50, y: 21 }, { code: 'DC', x: 74, y: 24 },
    { code: 'PG', x: 9, y: 54 },
    { code: 'MC', x: 33, y: 46 }, { code: 'MDC', x: 50, y: 39 }, { code: 'MC', x: 67, y: 46 },
    { code: 'PD', x: 91, y: 54 },
    { code: 'BU', x: 38, y: 81 }, { code: 'BU', x: 62, y: 81 },
  ],

  // La face défensive du 4-3-3, en bloc médian ou bas.
  '4-1-4-1': [
    { code: 'GB', x: 50, y: 4 },
    { code: 'DG', x: 12, y: 26 }, { code: 'DC', x: 34, y: 21 },
    { code: 'DC', x: 66, y: 21 }, { code: 'DD', x: 88, y: 26 },
    // La ligne de quatre descend d'un cran pour dégager la sentinelle, qui reste
    // l'écran bas que ce système décrit. Seize points partout, la contrainte tient.
    { code: 'MDC', x: 50, y: 37 },
    { code: 'AIG', x: 13, y: 57 }, { code: 'MC', x: 36, y: 54 },
    { code: 'MC', x: 64, y: 54 }, { code: 'AID', x: 87, y: 57 },
    { code: 'BU', x: 50, y: 83 },
  ],

  // ── Formes DÉFENSIVES. Ce ne sont pas des chips : ce sont les cibles du bouton
  // « sans ballon ». Un 5-2-2-1 n'est pas une formation qu'un entraîneur annonce,
  // c'est le 3-4-2-1 au moment où l'adversaire a le ballon et où les pistons
  // redescendent. L'exposer comme chip sœur ferait taper deux fois la même compo.
  '5-2-2-1': [
    { code: 'GB', x: 50, y: 4 },
    { code: 'PG', x: 10, y: 26 }, { code: 'DC', x: 30, y: 23 }, { code: 'DC', x: 50, y: 21 },
    { code: 'DC', x: 70, y: 23 }, { code: 'PD', x: 90, y: 26 },
    { code: 'MDC', x: 36, y: 44 }, { code: 'MDC', x: 64, y: 44 },
    { code: 'MOC', x: 32, y: 62 }, { code: 'MOC', x: 68, y: 62 },
    { code: 'BU', x: 50, y: 80 },
  ],

  '5-3-2': [
    { code: 'GB', x: 50, y: 4 },
    { code: 'PG', x: 10, y: 26 }, { code: 'DC', x: 30, y: 23 }, { code: 'DC', x: 50, y: 21 },
    { code: 'DC', x: 70, y: 23 }, { code: 'PD', x: 90, y: 26 },
    { code: 'MC', x: 33, y: 44 }, { code: 'MDC', x: 50, y: 39 }, { code: 'MC', x: 67, y: 44 },
    { code: 'BU', x: 38, y: 76 }, { code: 'BU', x: 62, y: 76 },
  ],
};

// Les formations proposées à la saisie. Le 4-3-2-1 « sapin » a été retiré : il a
// quasiment disparu de la Ligue 1 et n'est pas au répertoire de Still (Reims, Lens,
// Southampton). Une chip qui ne sera jamais tapée en 34 journées est une chip qui
// éloigne d'un demi-centimètre celles qu'on tape vraiment.
export const CHIPS = ['3-4-2-1', '4-3-3', '4-2-3-1', '3-4-3', '4-4-2', '3-5-2', '4-1-4-1'];

/**
 * La structure défensive de chaque formation — tout le « tableau tactique » en une
 * constante.
 *
 * Les tableaux de FORMATIONS sont ordonnés pour que l'index i désigne LE MÊME JOUEUR
 * dans les deux formes : basculer, c'est faire glisser onze jetons, pas recalculer une
 * composition. C'est la seule chose qu'un écran tactique apprenait vraiment, et elle
 * tient ici.
 */
export const PHASE_DEFENSIVE = {
  '3-4-2-1': '5-2-2-1',
  '3-4-3': '5-2-2-1',
  '3-5-2': '5-3-2',
  '4-3-3': '4-1-4-1',
  '4-2-3-1': '4-4-2',
  '4-4-2': '4-4-2',
  '4-1-4-1': '4-1-4-1',
};

export const existe = (cle) => Object.prototype.hasOwnProperty.call(FORMATIONS, cle);

/**
 * L'ordre des chips : la formation du dernier match d'abord.
 *
 * Ce n'est pas un détail d'affichage. « Still repasse à 3 derrière » est dit par le
 * commentateur avant qu'on ait lu un seul nom : la forme est l'information la plus
 * fiable et la plus tôt disponible, donc elle doit être à portée du pouce sans scroll.
 */
export function ordreChips(formationRecente) {
  if (!formationRecente || !CHIPS.includes(formationRecente)) return CHIPS;
  return [formationRecente, ...CHIPS.filter((c) => c !== formationRecente)];
}
